export const HIDE_HELP_BUTTON = 'HIDE_HELP_BUTTON';
export const RESET_HIDE_HELP_BUTTON = 'RESET_HIDE_HELP_BUTTON';
